import { mergeModels, useModel, resolveComponent, createBlock, openBlock } from "vue";
const _sfc_main = {
  __name: "BanzaNumberEdit",
  props: /* @__PURE__ */ mergeModels({
    format: {
      type: String
    }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const value = useModel(__props, "modelValue");
    return (_ctx, _cache) => {
      const _component_b_text_edit = resolveComponent("b-text-edit");
      return openBlock(), createBlock(_component_b_text_edit, {
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
        mask: __props.format ?? "float"
      }, null, 8, ["modelValue", "mask"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFOdW1iZXJFZGl0LnZ1ZS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQmFzZS9CYW56YU51bWJlckVkaXQudnVlIl0sInNvdXJjZXNDb250ZW50IjpbIjx0ZW1wbGF0ZT5cblx0PGItdGV4dC1lZGl0XG5cdFx0di1tb2RlbD1cInZhbHVlXCJcblx0XHQ6bWFzaz1cImZvcm1hdCA/PyAnZmxvYXQnXCIgLz5cbjwvdGVtcGxhdGU+XG5cbjxzY3JpcHQgc2V0dXA+XG5jb25zdCBwcm9wcyA9IGRlZmluZVByb3BzKHtcblx0Zm9ybWF0OiB7XG5cdFx0dHlwZTogU3RyaW5nLFxuXHR9LFxufSk7XG5cbmNvbnN0IHZhbHVlID0gZGVmaW5lTW9kZWwoKTtcbjwvc2NyaXB0PlxuIl0sIm5hbWVzIjpbIl91c2VNb2RlbCIsIl9jcmVhdGVCbG9jayJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQWFBLFVBQU0sUUFBUUEsOEJBQVk7OzswQkFaekJDLFlBRTZCLHdCQUFBO0FBQUEsb0JBRG5CLE1BQUs7QUFBQSxxRUFBTCxNQUFLLFFBQUE7QUFBQSxRQUNiLE1BQU0sUUFBTSxVQUFBO0FBQUE7Ozs7In0=
